<div style="margin: 10px; height: calc(100vh - 100px - 40px);">

  <!-- Install agent button -->
  @if (isLicenseValid) {
    <a href="{{ installAgentUrl }}" (click)="true" download pButton
    icon="fa fa-download" label="Install Agent Software" class="install-button"></a>
  }
  @if (!isLicenseValid) {
    <button type="button" class="install-button" download pButton icon="fa fa-download"
    [disabled]="true" label="Install Agent Software"></button>
  }

  <!-- Refresh client details button -->
  <button type="button" class="refresh-client-details-button" pButton icon="fa fa-refresh" (click)="refresh()"
  [disabled]="false" label="Refresh Client Details"></button>

	<!-- New agent button/dialog -->
	<button type="button" [disabled]="!canManageAgents" (click)="displayNewAgentDialog=true" pButton
			icon="fa fa-plus-square-o" label="Add Agent" class="add-button"></button>

  <new-agent-dialog [display]="displayNewAgentDialog" [parent]="network"
    (onClose)="onNewAgentDialogClose()">
  </new-agent-dialog>

  <!-- Search Box-->
  <div style="padding:4px 10px;border-bottom: 0 none">
    <i class="fa fa-filter" style="margin:4px 4px 0 0"></i>
    <input type="text" pInputText size="50" placeholder="Filter" (input)="tt.filterGlobal($event.target.value, 'contains')" style="width:auto">
  </div>
  <div>&nbsp;</div>

  <!-- Data table -->
  <p-table #tt [value]="agents" [columns]="cols" [globalFilterFields]="['Name', 'Description', 'Client ID', 'Client Machine']"
    [scrollable]="true" scrollHeight="calc(100vh - 180px - 90px)" rowHover="true" [resizableColumns]="true">

    <ng-template pTemplate="caption">
      <div>
        <button type="button" pButton icon="fa fa-file-o" iconPos="left" label="Export" (click)="tt.exportCSV()"></button>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn>Name</th>
        <th pResizableColumn>Description</th>
        <th pResizableColumn>Created</th>
        <th pResizableColumn>Modified</th>
        <th pResizableColumn>Agent ID</th>
        <th pResizableColumn>Client ID</th>
        <th pResizableColumn>Client Machine</th>
        <th pResizableColumn>Last Client Poll</th>
        <th pResizableColumn>Client SW Version</th>
        <th pResizableColumn class="uv-table-button-column-1"></th>
      </tr>
    </ng-template>

		<ng-template pTemplate="body" let-rowData>
			<tr (click)="onAgentClick(rowData.Guid)" class="uv-table-row">
				<td>
					<span class="uv-table-value">{{ rowData.Name }}</span>
				</td>
				<td>
					<span class="uv-table-value">{{ rowData.Description }}</span>
				</td>
				<td>
					<span class="uv-table-value">{{ formatDateHm(rowData.Created) }}</span>
				</td>
				<td>
					<span class="uv-table-value">{{ formatDateHm(rowData.Modified) }}</span>
				</td>
				<td>
					<span class="uv-table-value">{{ rowData.Guid }}</span>
				</td>
				<td>
					<span class="uv-table-value">{{ rowData.ClientAgentGuid }}</span>
				</td>
				<td>
					<span class="uv-table-value">{{ rowData.ClientAgentMachine }}</span>
				</td>
				<td [ngClass]="{'awol-agent': rowData.Awol}">
					<span class="uv-table-value">{{ formatDateHm(rowData.ClientAgentLastConfigPollTime) }}</span>
				</td>
				<td [ngClass]="{'version-mismatch-agent': rowData.VersionMismatch}">
					<span class="uv-table-value">{{ rowData.ClientAgentSoftwareVersion }}</span>
				</td>
				<td class="uv-table-button-column-1">
					<button type="button" [disabled]="!canManageAgents" class="btn btn-danger uv-first-table-button"
							title="Delete this agent" (click)="tryDeleteAgent($event, rowData.Guid)">
						<i class="pi pi-trash">
						</i>
					</button>
				</td>
			</tr>
		</ng-template>
	</p-table>

</div>


<confirmation-dialog message="Are you sure you want to delete this agent?"
  [display]="displayDeleteAgentConfirm"
  (onYes)="deleteAgent()" (onNo)="cancelDeleteAgent()">
</confirmation-dialog>
